import { render, staticRenderFns } from "./BookableStatistic.vue?vue&type=template&id=0d94b4b2"
import script from "./BookableStatistic.vue?vue&type=script&lang=js"
export * from "./BookableStatistic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports